import { Injectable } from '@angular/core';
import { BenchmarkPortfolio, BenchmarkResponse, IBenchmarkCompany, IBenchmarkCompanyAddResponse } from './monitoring.model';
import { HttpClient } from '@angular/common/http';

/** API client for benchmark portfolio read operations (public). */
@Injectable({
  providedIn: 'root'
})
export class BenchmarkService {
  /** Base endpoint for benchmark APIs */
  private readonly apiUrl = '/backend/benchmarks';

  constructor(private http: HttpClient) {}

  /** Get all benchmarks (public read-only) */
  getAllBenchmarks() {
    return this.http.get<BenchmarkResponse>(`${this.apiUrl}/public`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("current_user_token")
      },
      responseType: 'json'
    });
  }

  /** Get a specific benchmark by ID */
  getBenchmark(benchmarkId: number) {
    return this.http.get<BenchmarkResponse>(`${this.apiUrl}/${benchmarkId}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("current_user_token")
      },
      responseType: 'json'
    });
  }

  /** Get companies in a benchmark (204 when empty) */
  getBenchmarkCompanies(benchmarkId: number) {
    return this.http.get<IBenchmarkCompanyAddResponse>(`${this.apiUrl}/${benchmarkId}/companies`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("current_user_token")
      },
      responseType: 'json',
      observe: 'response'
    });
  }
}

